import { SafeError, SafePromise, SafeType } from '@benzinga/safe-await';
import { PlusProduct } from './entities';

export interface IncomingPlusProduct {
  permissions: string[][];
  slug: string;
  title: string;
  uuid: string;
  url: string;
  purchase_slugs: string[];
  visible: boolean;
  locked: boolean;
  chat_realm_general?: string | null;
}

export interface IncomingPlusProductsResult {
  products: IncomingPlusProduct[];
}

export const ingestProducts = async (
  plusProductsData: SafePromise<IncomingPlusProductsResult>,
): SafePromise<PlusProduct[]> => {
  const rawProducts = await plusProductsData;

  if (rawProducts.err) {
    return rawProducts as SafeType<PlusProduct[]>;
  } else {
    if (rawProducts.ok?.products) {
      return {
        ok: rawProducts.ok.products
          .filter(p => p.visible)
          .sort((a, b) => (a.locked === b.locked ? 0 : a.locked ? 1 : -1))
          .map(product => ({
            chatRealmGeneral: product.chat_realm_general ?? undefined,
            locked: product.locked,
            permissions: product.permissions.map(permission => ({ action: permission[0], resource: permission[1] })),
            purchaseSlugs: product.purchase_slugs,
            slug: product?.slug,
            title: product.title,
            url: product.url,
            uuid: product.uuid,
          })),
      };
    } else {
      return { err: new SafeError('did not get a valid plus product', 'invalid_plus_products') };
    }
  }
};
